import request from '../../../helpers/request';

const addRoomOwners = async (owners, room) => {
  await request.put(
    `/RentPlace/rental_house/office`,
    {
      ...room,
      landLords: owners,
    },
    'При добавлении собственника произошла ошибка'
  );
};

export default addRoomOwners;
